import { render, staticRenderFns } from "./SchoolEmployeeAwayApplicationPage.vue?vue&type=template&id=009ffba6&scoped=true&"
import script from "./SchoolEmployeeAwayApplicationPage.vue?vue&type=script&lang=js&"
export * from "./SchoolEmployeeAwayApplicationPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "009ffba6",
  null
  
)

export default component.exports